import { helper as buildHelper } from '@ember/component/helper';

/**
 * Get the model type or modalName from a specific instance of a model.
 *
 * @param params
 * @return {String}
 */
export function getModelType(params/*, hash*/) {
  let model = params[0];
  return model.constructor.modelName;
}

export default buildHelper(getModelType);
